// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:28:37

export default {
  "id": "bunnys-farm",
  "slug": "bunnys-farm",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/5ff36c1c4c1a4b48948f8e89126d3f14-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/5ff36c1c4c1a4b48948f8e89126d3f14/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bunnys Farm",
      "description": "Embark on a delightful fruit match-3 adventure with Bunny's Farm: Zen Match Master. Join your cheerful companion, Bunny, as you traverse diverse landscapes—from lush meadows and snowy peaks to desert dunes and tropical beaches. Match juicy fruits like oranges and peaches to solve engaging puzzles, uncover enchanting stories, and unlock new chapters in this relaxing yet challenging journey.",
      "instructions": "- Gameplay Basics: Swap adjacent fruits to align three or more identical ones, clearing them from the board.\n- Objective: Achieve specific goals for each level, such as reaching a target score or collecting designated fruits.\n- Power-Ups: Create special fruit combinations to generate power-ups that can clear rows, columns, or entire sections.\n- Progression: Advance through levels to explore new environments and encounter increasingly complex puzzles.",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "1player",
        "2d",
        "fruits",
        "match3",
        "matching"
      ]
    },
    "zh-CN": {
      "title": "兔兔农场",
      "description": "踏上充满乐趣的水果三消冒险之旅，加入Bunny's Farm: Zen Match Master。与你的快乐伙伴兔子一起穿越多样化的景观——从郁郁葱葱的草地到雪峰、沙漠沙丘和热带海滩。匹配多汁的水果如橙子和桃子，解决有趣的谜题，揭开迷人的故事，解锁轻松却又富有挑战性的旅程中的新篇章。",
      "instructions": "- 游戏基础：交换相邻的水果，使三个或更多相同的水果排列在一起，从棋盘上清除它们。\n- 目标：完成每个等级的具体目标，如达到目标分数或收集指定水果。\n- 加速器：创建特殊的水果组合，生成可以清除行、列或整个区域的加速器。\n- 进展：通过关卡来探索新的环境，并遇到越来越复杂的谜题。",
      "genres": [
        "三消游戏"
      ],
      "tags": [
        "1玩家",
        "2D",
        "水果",
        "匹配3",
        "匹配"
      ]
    },
    "zh-TW": {
      "title": "兔兔農場",
      "description": "啟航於一場令人愉悅的水果連線3關卡冒險，加入Bunny's Farm: Zen Match Master的快樂同伴Bunny，穿梭於多樣的風景中——從繁茂的草地、雪滿的山峰到沙漠沙丘和熱帶海岸。連線多汁的水果如橙子和桃子，解開引人入勝的謎題，揭開迷人的故事，並在這場放鬆又挑戰的旅程中啟封新篇章。",
      "instructions": "- 遊戲基本操作：交換鄰近的水果，將三個或以上相同的果物對齊，從遊戲板中清除它們。\n- 目標：達成每個關卡特定的目標，例如達到目標分數或收集指定的水果。\n- 加速器：創造特殊的果物組合，以產生能夠清除行、列或整個區域的加速器。\n- 過關進度：通過關卡來探索新的環境，並遭遇越來越複雜的謎題。",
      "genres": [
        "配對3"
      ],
      "tags": [
        "1人遊玩",
        "2D",
        "水果",
        "匹配3",
        "配對"
      ]
    },
    "zh-HK": {
      "title": "比尼農場",
      "description": "踏上愉悅的果物三消冒險之旅，隨著Bunny's Farm: Zen Match Master一起遊覽多樣風景——從綠意盎然的草地上到白雪皚皚的山峰，再到沙漠沙丘和熱帶海灘。匹配多汁的水果如橙子和桃子，解開引人入勝的謎題，揭開迷人的故事，啟動新篇章，這是一個輕鬆卻挑戰性十足之旅。",
      "instructions": "- 遊戲基本操作：交換鄰近的水果，將三個或以上相同的水果排列在一起，從遊戲板中清除它們。\n- 目標：達成每個關卡特定的目標，例如達到目標分數或收集指定的水果。\n- 項目加強：創造特殊的果物組合，以產生可以清除行、列或整個區域的加強功能。\n- 經驗提升：通過關卡進行進步，探索新環境並遇到越來越複雜的謎題。",
      "genres": [
        "配對3"
      ],
      "tags": [
        "1人玩",
        "2D",
        "水果",
        "匹配3",
        "配對"
      ]
    },
    "ja": {
      "title": "ビニーズ・ファーム",
      "description": "バニーのファーム：禅マッチマスターで楽しい果物マッチ3アドベンチャーに参加して、元気いっぱいの仲間、バニーと共に多様な風景を旅しましょう。オレンジやピーチなどの美味しい果物をマッチして、楽しいパズルを解き、魅力的な物語を発見し、リラックスしながらも挑戦的な旅の新たな章を開いてください。",
      "instructions": "- ゲームプレイの基本:隣接する果物を交換し、3つ以上の同じ果物を並べることで、それらをボードから消去します。\n- 目標:各レベルごとに特定の目標を達成します。たとえば、目標得点に達するか、指定された果物を収集するなどです。\n- パワーアップ:特別な果物の組み合わせを作成し、行や列、または全体のセクションを消去できるパワーアップを生成します。\n- プログレッションベース:レベルを進み、新しい環境を探索し、ますます複雑なパズルに直面します。",
      "genres": [
        "マッチ3"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "果物",
        "マッチ3",
        "一致"
      ]
    },
    "ko": {
      "title": "빅니의 far\n(원래 영어 표기는 \"Bunnys Farm\"인데, 한글로 번역할 경우 \"빅니의 농장\"으로 적합할 것 같습니다.)",
      "description": "뮤지의 농장: 젠 마치 마스터와 함께 기분 좋은 과일 매치 3 모험에 떠나세요. 즐거운 동반자 뮤지와 함께 다양한 풍경을 여행하세요 - 푸른 초원과 tuyu의 언덕, 사막 사막과 열대 해변까지. 오렌지와 복숭아와 같은 맛있는 과일을 매치하여 흥미로운 퍼즐을 해결하고, 매혹적인 이야기를 밝혀내며 이 편안하지만 도전적인 여행의 새로운 장을 열 수 있습니다.",
      "instructions": "- 게임 플레이 기본: 인접한 과일을 교환하여 세 개 이상의 같은 과일을 일치시키고, 보드에서 제거합니다.\n- 목표: 각 레벨마다 특정 목표를 달성합니다. 예를 들어, 목표 점수에 도달하거나 지정된 과일을 수집하는 것입니다.\n- 파워업: 특별한 과일 조합을 만들어 행렬, 열 또는 전체 섹션을 지우는 파워업을 생성합니다.\n- 진행: 레벨을 통과하여 새로운 환경을 탐험하고 점점 더 복잡한 퍼즐을 만나게 됩니다.",
      "genres": [
        "매치-3"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "과일",
        "매치3",
        "매칭"
      ]
    },
    "fr": {
      "title": "Ferme des Lapins",
      "description": "Embarkez sur une aventure delightful fruit match-3 avec Bunny's Farm: Zen Match Master. Rejoignez votre compagnon joyeux, Bunny, et traversez diverses paysages – des prairies luxuriantes et des sommets enneigés aux dunes de sable et aux plages tropicales. Faites correspondre des fruits succulents comme les oranges et les pêches pour résoudre des puzzles captivants, découvrir des histoires enchantées et déverrouiller de nouveaux chapitres dans ce voyage apaisant mais défiant.",
      "instructions": "- Fondamentaux du Gameplay : Échangez des fruits adjacents pour aligner trois ou plus de fruits identiques, et éliminez-les du plateau.\n- Objectif : Atteindre des objectifs spécifiques pour chaque niveau, tels que atteindre un score cible ou collecter des fruits désignés.\n- Power-Ups : Créez des combinaisons spéciales de fruits pour générer des power-ups qui peuvent nettoyer des rangées, des colonnes ou des sections entières.\n- Progrès : Avancez dans les niveaux pour explorer de nouveaux environnements et rencontrer des puzzles de plus en plus complexes.",
      "genres": [
        "Criss-Croix-3"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "fruits",
        "correspondance 3 en 1",
        "correspondance"
      ]
    }
  }
};
